import React, { memo } from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { BUTTON_AS_TYPE, BUTTON_TYPE } from '@motorway/mw-highway-code/enums';

import Texts from '../../../../texts.json';
import { RoundedSection } from '../../common/RoundedSection/RoundedSection';

import styles from './Career.scss';

const LocalT = new MDText(Texts);

const Career = memo(() => (
  <RoundedSection withBottomLedge className={styles.careerBox} theme="primary-yellow">
    <h2 className={ styles.title }>
      { LocalT.translate('aboutPage.career.title') }
    </h2>
    <p className={styles.description}>
      { LocalT.translate('aboutPage.career.description') }
    </p>
    <Button
      data-thc-button
      as={BUTTON_AS_TYPE.ANCHOR}
      href='https://careers.motorway.co.uk/'
      icon='chevron'
      label={LocalT.translate('aboutPage.career.button')}
      rel="noopener noreferrer"
      target="_blank"
      type={BUTTON_TYPE.BUTTON}
    />
  </RoundedSection>
));

export default Career;
